// extracted by mini-css-extract-plugin
export var container = "ff2cf";
export var dark = "f876d";
export var fullscreen = "ddfe8";
export var light = "_48a18";
export var loader = "be7e7";
export var normal = "_94419";
export var overlay = "_97e65";
export var small = "_32482";